import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import * as moment from 'moment';
import { ImportStudent } from '@ascschool/model/school/import-student';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { StudentService } from '@ascschool/services/school/student.service';
import { TrichXuat } from '@ascschool/model/school/trichxuat.model';
import { Student } from '@ascschool/model/school/student.model';

@Component({
  selector: 'app-pop-up-trich-xuat-thong-tin',
  templateUrl: './pop-up-trich-xuat-thong-tin.component.html',
  styleUrls: ['./pop-up-trich-xuat-thong-tin.component.scss']
})
export class TrichXuatThongTinPupupComponent implements OnInit {
  @Input() lstId: any;
  fileImport: File;
  discoloration: any;
  trichxuat = new TrichXuat();
  isImporting: Boolean = false;
  errorMsg: string;
  isDisabled: boolean = false;
  checklist : any[] = [];
  schoolName: string;
  masterSelected:boolean;
  commonFilter: CommonFilter = new CommonFilter();
  isEditMode = false; 
  validateForm!: FormGroup; 
  constructor(
    private service: StudentService,
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService, 
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.checklist = Object.keys(this.trichxuat);
  }
  
 
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }

  
  CheckAll(){  
    this.checklist.forEach(element => { 
      this.trichxuat[element] = true;
    }); 
  }
  TurnOffCheckAll(){  
    this.checklist.forEach(element => { 
      this.trichxuat[element] = false;
    }); 
  }
  exportExcel() { 
    // document.getElementById('btnvF').click(); 
   
      this.service.exportExcel(this.commonFilter).subscribe((data) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'TrichXuatThongTinNKT.xlsx';
        link.click();
      });
    
  }
 
}
